import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
// import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  targetId: null,
  values: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {targetId, botNotifyTo}) {
    commit('setTargetId', targetId)
    commit('setValues', botNotifyTo)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	}
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
